//ReactEcharts
import ReactEcharts from "echarts-for-react";

// react-router-dom components

// mui components

// mui-icons components

// prop-types is a library for typechecking of props.
// import PropTypes from "prop-types";
// import GraphLayout from "../layout/GraphLayout";

//routes

//prop-types
import PropTypes from "prop-types";

//utils
import { AppendStatsToCharts } from "../../../utils/AppendStatsToCharts";

const LineGraphs = ({ data = [] }) => {
    const reversedData = [...data].reverse();
    const seriesData = AppendStatsToCharts(reversedData);

    const labels = reversedData.map((item) => item.title);

    const seriesBars = [
        {
            data: seriesData,
            type: "line",
            barWidth: "80%",
            barGap: "-20%",
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                },
            },
        },
    ];

    const additionalLegends = labels.map((label) => ({
        name: label,
        type: "line",
        data: [],
        itemStyle: {
            color: "#5470C6",
        },
    }));

    const series = seriesBars.concat(additionalLegends);

    // Define chart options
    const option = {
        tooltip: {
            trigger: "item",
            confine: true,
            formatter: function (params) {
                let tooltipText = `<div style="text-align: left;">${params.name}: ${params.value}`;
                if (params.data.details) {
                    tooltipText += params.data.details.map((detail) => `<br/>${detail.name} : <span style={{fontWeight: 600}}>${detail.value}</span>`).join("");
                }
                tooltipText += `</div>`;
                return tooltipText;
            },
            textStyle: {
                fontSize: 12,
            },
        },
        legend: {
            top: "top",
            type: "scroll",
            selectedMode: false,
        },
        grid: {
            left: "10%",
            top: "20%",
            right: "5%",
            bottom: "28%",
        },
        xAxis: {
            type: "category",
            data: labels,
            axisLabel: {
                rotate: 45,
                width: 100,
                overflow: "break",
                lineHeight: 14,
                padding: [0, 10, 0, 10],
            },
        },
        yAxis: {
            type: "value",
        },
        series: series,
    };

    return (
        <div style={{ overflow: "auto" }}>
            <ReactEcharts
                option={option}
                style={{ minWidth: "500px", height: "400px" }}
                opts={{ renderer: "svg" }}
            />
        </div>
    );
};

// Typechecking props for the BarGraphs
LineGraphs.propTypes = {
    data: PropTypes.array,
};

export default LineGraphs;
